import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/AppShell";
import { RouteGuard } from "@/components/layout/RouteGuard";
import ProjectsManagement from "@/pages/ProjectsManagement";

const ProjectsRoute = () => {
  const { t } = useTranslation();

  return (
    <RouteGuard>
      <AppShell
        breadcrumbs={[
          { label: t("settings.title"), href: "/settings" },
          { label: t("projects.breadcrumbTitle"), current: true },
        ]}
        contentWidth="contained"
      >
        <ProjectsManagement />
      </AppShell>
    </RouteGuard>
  );
};

export const Route = createFileRoute("/projects")({
  component: ProjectsRoute,
});
